<template>
  <div>
    <IconDocument />
    <h2 class="weight-medium mt-20">
      Digital Signature
    </h2>
    <p class="body-2 weight-regular mt-10">
      
    You are about to sign the application form using a digital signature.
    We will send you the result of the digital signature verification by e-mail.
    A successful digital signature can only be done using a touchscreen device.
  
    </p>

    <div class="width-md mt-20">
      <Button
        class="btn-primary w-full mb-8"
        @click="startTransaction"
      >
        Sign
      </Button>
      <UpdateSignatureTypeRedirection/>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/Button.vue';
import enums from '@/mixins/enums';
import IconDocument from '@/components/Icons/IconDocument.vue';
import UpdateSignatureTypeRedirection
from '@/components/signatures/UpdateSignatureTypeRedirection.vue';

export default {
  name: 'DigitalSignatureRedirection',
  mixins: [enums],
  props: {
    model: { type: Object, required: true },
    uuid: { required: false, type: String, default: () => '' },
  },
  components: {
    UpdateSignatureTypeRedirection,
    IconDocument,
    Button,
  },
  methods: {
    async startTransaction() {
      try {
        this.model.loader = this.enums.LoaderEnum.WAIT_FOR_REDIRECTION;
        const request = {
          uuid: this.model.saveResponse[0].uuid,
          phone: '',
          signingType: 'REDIRECT',
        };
        const { data } = await this.$axios.post(`${process.env.VUE_APP_API_CONTEXT}/japi/IUzpApi/prepareTransaction`, [request]);
        window.location.replace(data.redirectUrl);
      } catch (e) {
        this.$router.maxStep = 22;
        this.$router.push({ name: 'ESignatureThankYou', query: this.$route.query, params: { uuid: this.model.saveResponse.uuid } });
      } finally {
        this.model.loader = null;
      }
    },
  },
};
</script>
